export default () => ({
    searchingData: {
        per_page: 10,
        page: 1,
        search: {
            general: ''
        },
        sort: {
            key: 'affiliation_code',
            asc: true
        }
    }
});
